import { useQuery } from "@tanstack/react-query";
import { getIrrDeals } from "@/api";
import { IrrDealFund } from "@/types";

export const useIrrDeals = () => {
  const query = useQuery<IrrDealFund[]>({
    queryKey: ["irrDeals"],
    queryFn: () => getIrrDeals(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};